import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js';

import axios from './axios'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus)

app.use(router); // 关键：挂载路由！
app.config.globalProperties.$axios = axios
app.use(Antd).mount('#app')